import TextBox from './TextBox';
import NumberInput from "./NumberInput";
import { useEffect } from 'react';

export function SupplyOwnFabric({ fabricData, errors, handleInputChange, onBlur = null  }) {

    return (
        <div className="mb-24">
            <div className="body-text3">Your Fabric Name Or Description:</div>
            <div className="body-text6 gray mt-12 max-width-460">
                If the fabric you like is not on our website, please email or call us on <a href="tel:0345 8620743" className="underline">0345 8620743</a> as we maybe able to source it for you at a competitive price. 
            </div>

            <div>
                {/* Description */}
                <div className="mt-16 no-input-group">
                    <TextBox
                        name="supplyOwnFabricNameOrDescription"
                        value={fabricData.supplyOwnFabricNameOrDescription}
                        onChange={handleInputChange}
                        onBlur={onBlur}
                    />
                    {errors.Description && (
                        <span className="field-validation-error">{errors.Description}</span>
                    )}
                </div>

                {/* Vertical Pattern Repeat and Fabric Roll Width */}
                <div className="mt-24 two-columns sm-column sm-gap-24">                               
                    <div>
                        <div className="body-text6 align-center gap-8">
                            <span>Vertical Pattern Repeat:</span>
                            <span className="curtains-icon curtains-icon-Info-circle size-24 gray"></span>
                        </div>
                        <div className="mt-8">
                            <NumberInput
                                name="VerticalPatternRepeat"
                                value={fabricData.VerticalPatternRepeat}
                                onChange={handleInputChange}
                                onBlur={onBlur}
                            />
                            {errors.VerticalPatternRepeat && (
                                <span className="field-validation-error">{errors.VerticalPatternRepeat}</span>
                            )}
                        </div>
                    </div>

                    <div>
                        <div className="body-text6 align-center gap-8 line-height-24">
                            <span>Fabric (Roll) Width:</span>
                        </div>
                        <div className="mt-8">
                            <NumberInput
                                name="FabricRollWidth"
                                value={fabricData.FabricRollWidth}
                                onChange={handleInputChange}
                                onBlur={onBlur}
                            />
                            {errors.FabricRollWidth && (
                                <span className="field-validation-error">{errors.FabricRollWidth}</span>
                            )}
                        </div>
                    </div>
                </div>

                <hr className="secodary-line mt-24 mb-16" />
            </div>
        </div>
    );
}
